import {SIDRender, SSegmentedTabs} from "shj-components";
import {Button, Empty, Pagination, Spin} from "antd";
import {DoubleRightOutlined, PhoneFilled} from "@ant-design/icons";
import {useSetState} from "ahooks";
import classNames from "classnames";
import styles from '../../index.module.less'
import {SearchModal} from "../SearchModal";
import {getNumberUnit} from "@/pages/roomMeasurementTools/roomMeasurementManage/utils.ts";
import React, {useEffect} from "react";
import {getCallPage} from "@/services/callCenter";
import {
  callDataAtom,
  callListAtom,
  callStateAtom
} from "@/pages/callTool/intelligentOutboundCall/components/Info/store";
import {useAtom} from "jotai";
import {onCallUp} from "@/pages/callTool/intelligentOutboundCall/components/Info/store/fn.tsx";
import { salesWorkPage } from "@/services/saleOpServices.ts";

export const CallList = () => {
  const [callList, setCallList] = useAtom(callListAtom)
  const [callData, setCallData] = useAtom(callDataAtom)
  const [callState] = useAtom(callStateAtom)
  const [state, setState] = useSetState({
    current: 0,
    searchOpen: false,
    searchValues: {},
    moreSearchValues: {},
    type: '',
    loading: false,
  })

  const [pages, setPages] = useSetState({
    pageId: 1,
    pageSize: 10,
    total: 0,
    list: [],
  })

  useEffect(() => {
    getData()
  }, [state.searchValues, state.moreSearchValues, callList.reload, pages.pageId, pages.pageSize]);

  const getData = () => {
    const pageId = pages.pageId || 1;
    const pageSize = pages.pageSize || 10;
    console.log('getData');
    setState({loading: true})
    salesWorkPage({ params: {pageId, pageSize}, data: {...state.searchValues, ...state.moreSearchValues} } ).then(res => {
      setPages({
        pageId: Number(res.currentPageId || 1),
        pageSize: Number(res.pageSize || 10),
        total: res.count,
        list: res.list,
      })
      setState({current: res.list?.[0]?.id})
      setCallList({...callList, userInfo: res.list?.[0] || {}})
    }).finally(() => setState({loading: false}))
  }

  const data = [
      {value: '', label: '全部'},
      {value: 'connectedFlag', label: '已接通'},
      {value: 'notConnectedFlag', label: '未接通'},
  ]

  const totalRender = (total: any) => <div>共{getNumberUnit(total, '', 2).numberValue}条</div>

  const onCall = (record) => {
    onCallUp({detailInfo: record, callData, setCallData, callState})
  }

  const onSearchType = (value) => {
    setState({type: value, searchValues: value ? {[value]: true} : {}});
    setPages({ pageId: 1 });
  }

  return <div className={styles.callListBox}>
    <div className={styles.flexBetween}>
      <SSegmentedTabs options={data} onChange={onSearchType} value={state.type}/>
      <Button style={{padding: 0}} type={'link'} onClick={() => setState({searchOpen: true})}>更多筛选<DoubleRightOutlined /></Button>
    </div>
    <Spin spinning={state.loading}>
      <div className={styles.callListScrollBox}>
        {pages.list?.length ? pages.list?.map((item) => {
          return <div key={item.id} className={classNames([styles.customerBox, item.id === state.current ? styles.customerBoxActive : ''])}
          onClick={() => {
            setState({current: item.id})
            setCallList({...callList, userInfo: item})
          }}>
            <div style={{display: 'flex', justifyContent: 'flex-start'}}>
              <span>{item.name}</span>
              <span className={styles.ml10}>{item.id}</span>
            </div>
            <div className={styles.mt10} style={{display: 'flex', justifyContent: 'flex-start'}}>
              <span>{item.phone}</span>
              <span className={styles.ml10}>
                 <div className={styles.callIconBox} onClick={() => onCall(item)}>
                    <PhoneFilled className={styles.callIcon}/></div>
              </span>
            </div>
            <div className={styles.mt10}>
              <span>拨打/接通：{item.totalCount || '0'}/{item.successCount || '0'} </span>
              <span className={styles.ml10}>最后状态：{(item.totalCount && item.totalCount != 0) ? '已拨打' : '未拨打'}</span>
            </div>
          </div>
        }) : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} style={{marginTop: '50%'}}/>}
      </div>
    </Spin>
    <Pagination style={{padding: '10px 0'}}
                simple
                size="small"
                align={'end'}
                total={pages.total}
                showTotal={totalRender}
                current={pages.pageId}
                pageSize={pages.pageSize}
                onChange={(pageId, pageSize) => {
                  setPages({
                    pageId: pageId || 1,
                    pageSize: pageSize || 10,
                  });
                }}
    />
    <SearchModal open={state.searchOpen}
                 values={state.moreSearchValues}
                 onClose={() => {
                   setState({ searchOpen: false });
                 }}
                 onSearch={searchValues => {
                   setState({ moreSearchValues: searchValues });
                   setPages({ pageId: 1 });
                 }}/>
  </div>
}